
<img src="assets/icons/svet-icon.svg" alt="">
<ul>
    <h4>à propos de Svet</h4>
    <li><a routerLink="/privacy">{{ 'policy.title' | translate }}</a></li>
    <li><a routerLink="/terms">{{ 'terms.title' | translate }}</a></li>
</ul>